import React, { useState } from "react";
import { Link } from "react-router-dom";
import { notification } from "antd";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { Eye } from "iconsax-react";
import axios from "axios";
import moment from "moment";

import ModalLoading from "../../../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../../../shared/components/Modals/ModalViewer";

import styles from "./NomeBara.module.scss";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

export default function NomeBara({ num, nome, handlerClick, total, periodo, isSAT, cursoId }) {
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const carregarBoletimEscolar = () => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/boletim-escolar",
            params: {
                cursoId: cursoId,
                dataEmissao: moment().format("YYYY/MM/DD")
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                setVisibleLoading(false);
            });
    };

    return (
        <>
            <div className={styles.barra}>
                <div className={styles.nome}>
                    <span>{nome}</span>
                </div>
                {isSAT ? (
                    <div className={`${styles.bimestre} ${styles.oculto}`}>
                        ´
                    </div>
                ) : (
                    <div className={styles.bimestre}>
                        <button onClick={() => handlerClick(num - 1)} disabled={num === 1}>
                            <FaAngleLeft color="#647177" />
                        </button>
                        <span>{periodo?.titulo}</span>
                        <button onClick={() => handlerClick(num + 1)} disabled={num === total}>
                            <FaAngleRight color="#647177" />
                        </button>
                    </div>
                )}
                <div className={styles.boletim}>
                    <Link
                        to="#"
                        title="Visualizar"
                        className="botao-boletim-escolar"
                        onClick={() => {
                            carregarBoletimEscolar();
                        }}
                    >
                        <Eye size="24" color="#FFFFFF" />
                        Boletim Escolar
                    </Link>
                </div>
            </div>

            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
}
